import { MdStar, MdStarBorder } from 'react-icons/md';

import { cn } from '../../lib/cn';

/** 0 to 5 stars, read only. */
export function StarsDisplay({ value, className }: { value: number; className?: string }) {
  return (
    <span
      role="img"
      aria-label={`${value} sur 5`}
      className={cn('inline-flex text-gold-500', className)}
    >
      {[1, 2, 3, 4, 5].map((n) =>
        n <= value ? (
          <MdStar key={n} className="size-4" />
        ) : (
          <MdStarBorder key={n} className="size-4" />
        ),
      )}
    </span>
  );
}
